import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../components/Translate/TranslateContext";

function extractVersion(filename) {
    const match = filename.match(/(\d{4}_\d{2})/);
    return match ? match[1] : null;
}

export default function TermsAndConditions() {
    const { language, translate } = useTranslate();
    const navigate = useNavigate();

    const [pdfUrl, setPdfUrl] = useState(null);

    const langCode =
        (language || navigator.language || "en").split("-")[0];

    useEffect(() => {
        (async () => {
            const res = await fetch("/legal/terms-manifest.json");
            const manifest = await res.json();

            const filesByLang = manifest.files || {};
            const defaultLang = manifest.default_language || "en";

            const candidateFiles =
                filesByLang[langCode] ||
                filesByLang[defaultLang] ||
                [];

            if (!candidateFiles.length) return;

            const latestFile = candidateFiles
                .map(f => ({ file: f, version: extractVersion(f) }))
                .filter(f => f.version)
                .sort((a, b) => b.version.localeCompare(a.version))[0]?.file;

            if (latestFile) {
                setPdfUrl(`/legal/${latestFile}`);
            }
        })();
    }, [langCode]);

    const handleBack = () => {
        if (window.history.length > 1) navigate(-1);
        else navigate("/login");
    };

    if (!pdfUrl) return null;

    return (
        <Box
            sx={{
                height: "100dvh",
                display: "flex",
                flexDirection: "column",
                bgcolor: "var(--color-green-strong)",
            }}
        >
            <Box
                sx={{
                    px: 1.5,
                    py: 1.25,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.25,
                    borderBottom: "1px solid rgba(255,255,255,0.12)",
                    flexShrink: 0,
                }}
            >
                <IconButton
                    onClick={handleBack}
                    size="small"
                    disableRipple
                    sx={{
                        color: "var(--color-text-inverse)",
                        "&:hover": {
                            backgroundColor: "rgba(255,255,255,0.08)",
                        },
                    }}
                >
                    <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>

                <Typography
                    variant="subtitle1"
                    sx={{
                        color: "var(--color-text-inverse)",
                        fontWeight: 500,
                    }}
                >
                    {translate("terms_conditions")}
                </Typography>
            </Box>

            <Box sx={{ flex: 1, minHeight: 0 }}>
                <iframe
                    title="Terms and Conditions"
                    src={pdfUrl}
                    style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        background: "var(--color-bg-primary)",
                    }}
                />
            </Box>
        </Box>
    );
}